<template>
    <div class="land-about">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.project_shablon_fields.about_section_title_img + ')'"></div>
            <h2>{{salesCard.project_shablon_fields.about_second_title}}</h2>
        </div>
        <div class="container">
            <div class="land-about-column-container">
                <div class="col-right" v-if="!isMobileChecker">
                    <div class="col-img">
                        <img :src="salesCard.project_shablon_fields.about_img" alt="">
                    </div>
                </div>
                <div class="col-left">
                    <div class="section-title" v-if="!isMobileChecker">
                        <h2>{{salesCard.project_shablon_fields.about_second_title}}</h2>
                    </div>
                    <div class="desc-html" v-html="salesCard.project_shablon_fields.about_desc"></div>
                    <!-- <a :href="salesCard.project_shablon_fields.present_file.file" target="_blank"  class="present-link" v-if="salesCard.project_shablon_fields.present_file.file != false">
                        <svgIcon name="pdf" />
                        <p>{{salesCard.project_shablon_fields.about_btn_present}}</p>
                    </a> -->
                    <a :href="salesCard.project_shablon_fields.present_file.file" target="_blank"  class="present-link" v-if="salesCard.project_shablon_fields.present_file.file != false && globalLang != 'kz/'">
                        <svgIcon name="pdf" />
                        <p>{{salesCard.project_shablon_fields.about_btn_present}}</p>
                    </a>
                    <a :href="salesCard.project_shablon_fields.present_file.file_kz" target="_blank"  class="present-link" v-if="salesCard.project_shablon_fields.present_file.file_kz != false && globalLang == 'kz/'">
                        <svgIcon name="pdf" />
                        <p>{{salesCard.project_shablon_fields.about_btn_present}}</p>
                    </a>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-about',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-about.scss';
    @import '@/styles/components/sales/respond/land-about-respond.scss';

    // @import '@/styles/respond/sales/sales-land-partials/land-about-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>